import * as request from '@/utils/request'
import { getLevel } from '@/utils/chat/chatUtil';
import { param } from 'jquery';

let api = '';


// 交互学习智能体的首页信息
export const getExerciseRecommands = () => request.post(api + '/ShowLearning', {level: getLevel(), _t: Date.now()})

// 组卷智能体的首页信息
export const getExamRecommands = () => request.post(api + '/ShowExams', {level: getLevel(), _t: Date.now()})

// 展示年级
export const showGrade = () => request.post(api + '/ShowGrade')

// 更新年级
export const updateGrade = (params) => request.post(api + '/UpdateGrade',params)


// 展示昵称
export const showNickName = () => request.post(api + '/ShowNickName')

// 更新昵称
export const updateNickName = (params) => request.post(api + '/UpdateNickName', params)

// 每日一题
export const getDayRecommand = () => request.post(api + '/RecommendForDay', {level: getLevel()})

// 安装包列表
export const showPackageList = () => request.get(api + '/PackageList')

//用户订单
export const queryOrders = () => request.post(api + '/queryOrders')
